import _ from 'lodash';
import { createClient } from '@/shared/api';
import RMA_TICKET_QUERY from '../queries/rmaTicket';

/**
 * Loads a single RMA ticket by its identifier. Runs RMA_TICKET_QUERY and throws the first GraphQL error message when the RmaTicket field is nil, otherwise returning the ticket.
 *
 * @param id - Identifier of the RMA ticket to load.
 * @returns The RMA ticket record.
 */
const fetchRmaTicket = async (id: any) => {
  const client = createClient();
  const result = await client.query({
    query: RMA_TICKET_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = result;
  const { RmaTicket } = data;
  if (_.isNil(RmaTicket) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return RmaTicket;
};

export default fetchRmaTicket;
